import { useParams } from "react-router-dom";
import Screen1 from "./Screen1/Screen1";
import Screen2 from "./Screen2/Screen2";
import Screen3 from "./Screen3/Screen3";
import { useMediaQuery } from "@mui/material";

const InfoGraphics = () => {
  const { screen } = useParams();
  const isMobile = useMediaQuery("(max-width: 839px)");

  if (screen === "0")
    return isMobile ? (
      <Screen1 />
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "50rem" }}>
          <Screen1 />
        </div>
      </div>
    );
  if (screen === "1")
    return isMobile ? (
      <Screen2 />
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "50rem" }}>
          <Screen2 />
        </div>
      </div>
    );
  if (screen === "2")
    return isMobile ? (
      <Screen3 />
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "50rem" }}>
          <Screen3 />
        </div>
      </div>
    );
  else return <div>InfoGraphics</div>;
};

export default InfoGraphics;
